import { Link, NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { NAV_LINKS, VERTICALS } from "@/lib/content";
import { Icon } from "@/components/common/Icon";
import { TellUsButton } from "@/components/common/TellUsButton";
import { MegaMenu } from "./MegaMenu";
import { cn } from "@/lib/utils";

const MOBILE_MOTION = { initial: { opacity: 0, height: 0 }, animate: { opacity: 1, height: "auto" },
  exit: { opacity: 0, height: 0 }, transition: { duration: 0.3 } };
const navId = (label) => label.toLowerCase().replace(/\s+/g, "-");
const linkColor = (active, dark) => active
  ? (dark ? "text-white" : "text-blue-700")
  : (dark ? "text-slate-300 hover:text-white" : "text-slate-700 hover:text-blue-700");
const linkClass = (active, dark) => cn("rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200", linkColor(active, dark));

export const DesktopNav = ({ dark, megaOpen, setMegaOpen }) => (
  <nav className="hidden items-center gap-1 lg:flex" data-testid="primary-nav">
    {NAV_LINKS.map((link) => link.hasMega ? (
      <div key={link.to} className="relative" onMouseEnter={() => setMegaOpen(true)} onMouseLeave={() => setMegaOpen(false)}>
        <NavLink to={link.to} data-testid={`nav-${navId(link.label)}`}
          className={({ isActive }) => cn(linkClass(isActive, dark), "flex items-center gap-1")}>
          {link.label}<ChevronDown className={cn("h-3.5 w-3.5 transition-transform duration-200", megaOpen && "rotate-180")} />
        </NavLink>
        <AnimatePresence>
          {megaOpen && <div className="absolute left-1/2 top-full -translate-x-1/2 pt-3"><MegaMenu onNavigate={() => setMegaOpen(false)} /></div>}
        </AnimatePresence>
      </div>
    ) : (
      <NavLink key={link.to} to={link.to} end={link.to === "/"} data-testid={`nav-${navId(link.label)}`}
        className={({ isActive }) => linkClass(isActive, dark)}>{link.label}</NavLink>
    ))}
  </nav>
);

export const MobileNav = ({ open, onNavigate }) => (
  <AnimatePresence>
    {open && (
      <motion.div {...MOBILE_MOTION} className="overflow-hidden border-t border-border bg-white lg:hidden" data-testid="mobile-nav">
        <div className="space-y-1 px-5 py-5">
          {NAV_LINKS.map((link) => (
            <NavLink key={link.to} to={link.to} end={link.to === "/"} onClick={onNavigate} data-testid={`mobile-nav-${navId(link.label)}`}
              className={({ isActive }) => cn("block rounded-xl px-4 py-3 text-base font-medium transition-colors",
                isActive ? "bg-blue-50 text-blue-700" : "text-slate-800 hover:bg-slate-50")}>{link.label}</NavLink>
          ))}
          <div className="grid grid-cols-1 gap-2 pt-3">
            {VERTICALS.map((vertical) => (
              <Link key={vertical.id} to={`/services#${vertical.id}`} onClick={onNavigate} data-testid={`mobile-vertical-${vertical.id}`}
                className="flex items-center gap-2 rounded-lg px-4 py-2 text-sm text-slate-500">
                <Icon name={vertical.services[0].icon} className="h-4 w-4 text-blue-600" />{vertical.name}
              </Link>
            ))}
          </div>
          <div className="pt-4"><TellUsButton className="w-full justify-center" testId="mobile-tell-us-cta" onSelect={onNavigate} /></div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);